import { Entity } from "../../../helpers/Entity"

export type PaymentTransactionElasticDto = {
    creditMemoId: string
    parentId: string
    parentIdentifier: string
    objectType: string
    status: string
    contact: PaymentTransactionContactElasticDto
    amount: string
}

export type PaymentTransactionContactElasticDto = {
    id: string
    name: string
}


export class PaymentTransactionElastic implements Entity {
    private dto: PaymentTransactionElasticDto

    constructor(dto: PaymentTransactionElasticDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return true

    }

    getId(): string {
        return this.dto.parentIdentifier
    }

    getCreditMemoId(): string {
        return this.dto.creditMemoId
    }

    getParentId(): string {
        return this.dto.parentId
    }

    getObjectType(): string {
        return this.dto.objectType
    }

    getStatus(): string {
        return this.dto.status
    }

    getContactName(): string {
        return this.dto.contact.name
    }

    getContactId(): string {
        return this.dto.contact.id
    }

    getAmount(): string {
        return this.dto.amount
    }
}


// WEBPACK FOOTER //
// ./src/state/listing/payment-transactions/models/paymentTransactionElastic.ts